import React from 'react';
import { ProfileSettingsPersonalInformation } from './ProfileSettingsPersonalInformation';
import { ProfileSettingsAccountSecurity } from './ProfileSettingsAccountSecurity';
import { ProfileSettingsPreferences } from './ProfileSettingsPreferences';
// import { ProfileSettingsAccount } from './ProfileSettingsAccount';

export const ProfileInformationWrapper = (): JSX.Element => {
	return (
		<>
			<ProfileSettingsPersonalInformation/>
			<ProfileSettingsAccountSecurity/>
			<ProfileSettingsPreferences/>
			{/*<ProfileSettingsAccount/>*/}
		</>
	);
};
